'use strict';

angular.module('shiftTraderApp')
  .controller('BaseSmartCWPListItemCtrl', function BaseSmartCWPCtrl($scope, $log, $rootScope,
                                                            TimeService, WeightCalculationService, AvailabilityService) {
    var _this = this;

    // clear out all of the temporary $scope.emp.xxxx values so that re-open's don't bleed values over
    $scope.emp.availabilityIndex = undefined;
    $scope.emp._blackout = 0;
    $scope.emp._availabilityIntersection = undefined;
    $scope.emp._overlap = undefined;
    $scope.emp._targetHoursWeighting = undefined;
    $scope.emp._overtimeWeighting = undefined;
    $scope.emp._multiShift = undefined;
    $scope.emp._colorClassName = undefined;
    $scope.emp._hoursThisWeek = undefined;


    $scope.state = {
      isAssignedToShift: false,
      creationInProgress: false,
      busyCalculating: true
    };

    $scope.sendEmpToInfoBar = function() {
      $rootScope.$broadcast('sa:employeeSelectedForInfo', $scope.emp);
    };

    $scope.getViolationDescription = AvailabilityService.getAvailabilityViolationDescription;

    var lastColorClassName;
    $scope.$watch('emp.availabilityIndex', function(ai) {

      $scope.emp._colorClassName = WeightCalculationService.getLabelColorForAvailabilityIndex(ai, $scope.emp._blackout);

      if ($scope.emp._colorClassName !== lastColorClassName) {
        $scope.setColorClass($scope.emp._colorClassName);
      }

      lastColorClassName = $scope.emp._colorClassName;
    });

    this.calcCurrentDate = function() {
      $scope.currentDate = TimeService.getBeginningOfDayFromDateWithOrgSetting($scope.shift.start_time);
      $scope.currentDateTwix = $scope.currentDate.twix(moment($scope.currentDate).add(24, 'hours'));
    };

    this.doConnectingShiftDetection = function(currentShift, currentDayTwix, workPeriodsWithoutCurrentShift) {
      //console.log('doConnectingShiftDetection', $scope.emp.name, currentShift.range_twix.format());

      var empWorkPeriods = lodash.filter(workPeriodsWithoutCurrentShift, function(wp) {
        return wp.user.id === $scope.emp.id;
      });

      var results = [];

      lodash.forEach(empWorkPeriods, function(wp) {
        if (wp.range_twix.start.isSame(currentShift.range_twix.end, 'minute')) {
          results.push({
            weight: 1,
            location: 'before',
            workPeriod: wp,
            wpLength: wp.range_twix.length('minutes') / 60.0
          });
        } else if (wp.range_twix.end.isSame(currentShift.range_twix.start, 'minute')) {
          results.push({
            weight: 1,
            location: 'after',
            workPeriod: wp,
            wpLength: wp.range_twix.length('minutes') / 60.0
          });
        }
      });

      if (results.length === 0) {
        return {
          type: 'connectingShift',
          weight: 0
        };
      } else {
        var totalShiftLength = currentShift.range_twix.length('minutes') / 60.0 + +lodash.reduce(results, function(sum, obj) {return sum + obj.wpLength;}, 0);

        return {
          type: 'connectingShift',
          weight: totalShiftLength > 12 ? 1 : (+lodash.reduce(results, function(sum, obj) {return sum + obj.weight;}, 0) * 10),
          data: results
        };
      }
    };
  });
